<template>
  <div class="">
    <Page :title="pageTitle" :isFullWidth="true">
      <template v-slot:action> </template>
      <template v-slot:default>
        <div class="">
          <div>
            <div class="Polaris-Tabs__Outer  max-w-6xl mx-auto">
              <div
                class="Polaris-Box"
                style="--pc-box-padding-block-start-md:var(--p-space-200);--pc-box-padding-block-end-md:var(--p-space-200);--pc-box-padding-inline-start-md:var(--p-space-200);--pc-box-padding-inline-end-md:var(--p-space-200)"
              >
                <div class="Polaris-Tabs Polaris-Tabs__TabsMeasurer">
                  <li
                    v-for="(tab, index) of tabs"
                    :key="index"
                    class="Polaris-Tabs__TabContainer"
                    role="presentation"
                  >
                    <button
                      :id="tab.routeName + 'Measurer'"
                      class="Polaris-Tabs__Tab"
                      :class="{
                        'Polaris-Tabs__Tab--active':
                          $route.name === tab.routeName
                      }"
                      role="tab"
                      type="button"
                      tabindex="-1"
                      :aria-selected="$route.name === tab.routeName"
                    >
                      <div
                        class="Polaris-InlineStack"
                        style="--pc-inline-stack-align:center;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:nowrap;--pc-inline-stack-gap-xs:var(--p-space-200);--pc-inline-stack-flex-direction-xs:row"
                      >
                        <span
                          class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                          >{{ tab.label }}</span
                        >
                      </div>
                    </button>
                  </li>
                </div>
                <div class="Polaris-Tabs__Wrapper">
                  <div class="Polaris-Tabs__ButtonWrapper">
                    <ul
                      class="Polaris-Tabs"
                      data-tabs-focus-catchment="true"
                      role="tablist"
                    >
                      <li
                        v-for="(tab, index) of tabs"
                        :key="index"
                        class="Polaris-Tabs__TabContainer"
                        role="presentation"
                      >
                        <router-link
                          :id="tab.routeName"
                          event
                          class="Polaris-Tabs__Tab"
                          :class="{
                            'Polaris-Tabs__Tab--active':
                              $route.name === tab.routeName
                          }"
                          :aria-label="tab.label"
                          role="tab"
                          :to="{ name: tab.routeName }"
                          :aria-controls="tab.routeName + '-content'"
                          :tabindex="$route.name === tab.routeName ? 0 : -1"
                          :aria-selected="$route.name === tab.routeName"
                          @click.native.prevent="handleNavClick(tab)"
                        >
                          <div
                            class="Polaris-InlineStack"
                            style="--pc-inline-stack-align: center; --pc-inline-stack-block-align: center; --pc-inline-stack-wrap: nowrap; --pc-inline-stack-gap-xs: var(--p-space-200); --pc-inline-stack-flex-direction-xs: row;"
                          >
                            <span
                              class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                              >{{ tab.label }}</span
                            >
                          </div>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="Polaris-Tabs__Panel w-full"
              :id="$route.name + '-content'"
              role="tabpanel"
              :aria-labelledby="$route.name"
              tabindex="-1"
            >
              <div class="Polaris-LegacyCard__Section">
                <router-view></router-view>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
import Page from "../Common/Page";
export default {
  components: {
    Page
  },
  data() {
    return {
      pageTitle: "Automation",
      tabs: [
        {
          label: "Abandoned Cart",
          routeName: "AutomationConfigure"
        },
        {
          label: "Order Confirmation",
          routeName: "OrderConfirmation"
        },
        {
          label: "Order Shipping updates",
          routeName: "OrderShippingUpdates"
        },
        {
          label: "COD order Confirmation",
          routeName: "CodOrder"
        },
        {
          label: "Reviews",
          routeName: "IntegrationList"
        },
        {
          label: "Message Logs",
          routeName: "MessageLogs"
        },
        {
          label: "Faqs",
          routeName: "Faqs"
        }
      ]
    };
  },
  created() {
    // Only add the tab for specific storeIds
    if (
      this.$store.getters.getStore &&
      [
        "66aca6426797ece6eac6588f",
        "65bcd94044e0ae19952b4711",
        "65e5fb9bb7db72bb312ef67c"
      ].includes(this.$store.getters.getStore._id)
    ) {
      this.tabs.push({
        label: "Order Tracking Uploader",
        routeName: "OrderTrackingUploader"
      });
    }
  },
  methods: {
    openIntegrations() {
      this.$router.push({ name: "Integrations" });
    },
    handleNavClick(tab) {
      console.log(tab);
      const saveBar = document.getElementById("my-save-bar");
      if (saveBar && saveBar.showing) {
        console.log("savebar showing");
        // saveBar.leaveConfirmation();
        // eslint-disable-next-line
        shopify.saveBar.leaveConfirmation();
        // history.pushState(null, "", `#/${tab.routeName}`);
      } else {
        this.$router.push({ name: tab.routeName });
      }
    }
  }
};
</script>

<style></style>
